import { UnixEpochTimeStamp } from "@bracket/in-or-out-server";

export const timeAgo = (timestamp: UnixEpochTimeStamp): string => {
  const now = Date.now(); // Current time in milliseconds
  const diffInMilliseconds = now - timestamp;
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000); // Convert to seconds

  if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} h ago`;
  return `${Math.floor(diffInSeconds / 86400)} d ago`;
};
